var _path, _path2, _path3, _path4, _polygon, _polygon2, _rect, _path5, _rect2, _path6, _circle, _polygon3, _rect3, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _rect4, _path16, _path17, _path18, _circle2, _polygon4, _path19, _polygon5, _path20, _path21, _rect5, _rect6, _ellipse, _circle3, _circle4, _path22, _path23, _path24, _path25, _rect7, _rect8, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreDraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 832.02831,
    height: 646,
    viewBox: "0 0 832.02831 646",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "efdf5e1f-6b90-40c1-9274-afa2b16f39be-1750",
    "data-name": "Path 482",
    d: "M710.36347,771.35677s-12.753-31.391,25.505-54.934Z",
    transform: "translate(-183.98585 -127)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "af7fe47f-56e6-4bb6-aa0f-d6efaf86a160-1751",
    "data-name": "Path 483",
    d: "M694.67951,770.78573s-3.89-22.374-34-22.182Z",
    transform: "translate(-183.98585 -127)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a08d42bc-6ae2-46d7-9736-aba59e52cc48-1752",
    "data-name": "Path 482",
    d: "M982.31864,771.35677s-16.8484-41.47168,33.69551-72.57516Z",
    transform: "translate(-183.98585 -127)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "bafd7749-4c33-42a1-9524-e744b9f16454-1753",
    "data-name": "Path 483",
    d: "M961.598,770.60235s-5.13923-29.55906-44.91853-29.30538",
    transform: "translate(-183.98585 -127)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "483.215 179.569 466.576 170.731 467.821 170.069 484.46 178.908 483.215 179.569",
    fill: "#cbcbcb"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "468.701 179.569 467.457 178.908 484.095 170.069 485.34 170.731 468.701 179.569",
    fill: "#cbcbcb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 529.91509,
    y: 237.40898,
    width: 1.76077,
    height: 5.28154,
    transform: "translate(-108.89116 475.96091) rotate(-62.86776)",
    fill: "#cbcbcb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M626.30017,289.97841l-9.35556-4.794.80288-1.56707,9.35555,4.794Zm-18.71111-9.58808-9.35577-4.79447.80288-1.56706,9.35577,4.79447Zm-18.71132-9.5885-9.35555-4.794.80287-1.56707,9.35555,4.794Zm-18.71111-9.58808-9.35577-4.794.80288-1.56707,9.35577,4.794Zm-18.71132-9.58808-9.35555-4.794.80287-1.56707,9.35555,4.794Z",
    transform: "translate(-183.98585 -127)",
    fill: "#cbcbcb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 637.52695,
    y: 292.55246,
    width: 1.76077,
    height: 5.28154,
    transform: "translate(-99.43051 601.7263) rotate(-62.86776)",
    fill: "#cbcbcb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M281.557,355.92045q0,.82486-.05345,1.63595a24.78151,24.78151,0,0,1-2.322,8.9969c-.01036.02414-.02248.04655-.03275.069-.06212.131-.12592.262-.19141.39133a24.48771,24.48771,0,0,1-1.31874,2.32723,24.90345,24.90345,0,0,1-20.43827,11.50168l.24655,14.17714,3.215-1.69285.57407,1.09122-3.76492,1.98246.46026,26.33045.00514.35168-2.48581.55335.00513-.35339.78265-42.43833a24.854,24.854,0,0,1-17.58352-7.65056c-.15682-.162-.312-.32925-.46371-.49475l-.01726-.019a24.95626,24.95626,0,0,1-4.54066-7.02651c.02416.02757.05.05344.07416.081a24.93445,24.93445,0,0,1,11.82226-32.12957c.08619-.04309.17415-.08447.26035-.12756a24.95344,24.95344,0,0,1,32.32778,9.814c.15176.25514.29831.51545.43963.77747A24.79836,24.79836,0,0,1,281.557,355.92045Z",
    transform: "translate(-183.98585 -127)",
    fill: "#e5e5e5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.21547,
    cy: 206.96164,
    r: 32.67421,
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.07573,312.13783a32.67676,32.67676,0,0,0,54.4449,34.58143,32.677,32.677,0,1,1-54.4449-34.58143Z",
    transform: "translate(-183.98585 -127)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "95.983 297.986 92.646 297.05 92.653 296.691 93.653 242.341 93.703 239.631 93.704 239.552 93.879 230.056 94.132 216.293 94.132 216.291 94.304 206.962 94.396 206.962 94.572 217.069 94.801 230.224 94.965 239.558 94.965 239.627 94.972 240.012 94.972 240.014 95.289 258.209 95.322 260.017 95.977 297.624 95.983 297.986",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 278.11154,
    y: 384.31943,
    width: 6.10398,
    height: 1.61576,
    transform: "translate(-331.02755 48.32681) rotate(-27.76587)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M701.75535,228.21636a832.27432,832.27432,0,0,0-123.7512,1.90225c-19.83159,1.7926-39.97869,3.72884-59.44387,8.05478-15.67852,3.48439-33.87519,9.37352-43.64416,23.09031a22.29072,22.29072,0,0,0-3.48031,19.51361c2.32927,7.8194,8.1236,14.3282,14.29449,19.42613,14.20265,11.73315,31.82451,18.56081,47.56541,27.88244,28.74,17.01962,55.04314,39.95976,71.926,69.101,7.42913,12.82336,14.49591,29.874,6.2236,44.0038-8.10421,13.84268-26.19574,18.61175-40.9496,20.86074-18.49256,2.81891-37.54111,2.05432-56.11081.47581a584.64766,584.64766,0,0,1-60.65107-8.88336c-39.27483-7.54145-78.19214-17.13457-118.0128-21.497a341.78066,341.78066,0,0,0-60.16964-1.7399c-18.12434,1.22252-36.40391,4.08928-53.43038,10.62453-13.12036,5.036-27.106,12.65528-34.1931,25.362-6.83165,12.24873-4.16709,26.37387,3.27173,37.675,8.95042,13.59759,22.90733,22.91539,37.41794,29.72573,16.5216,7.75418,34.193,12.78041,51.887,17.055,8.97389,2.168,17.99633,4.12771,27.0196,6.07749,1.88238.40675,2.68668-2.48462.79752-2.89283-18.19619-3.9319-36.445-7.87666-54.18932-13.56844-16.42046-5.26714-33.22462-12.01436-46.67151-23.07433-10.87857-8.94753-21.22184-22.01667-20.57974-36.87588.64729-14.97943,13.21537-25.43824,25.5338-31.87585,15.39459-8.04521,32.885-11.9641,50.02355-14.01231a303.93666,303.93666,0,0,1,59.0905-.80365c39.72671,3.02277,78.56576,12.07225,117.51641,19.96558,37.83967,7.66819,76.86045,14.76886,115.63881,12.80206,15.37019-.77956,31.83919-2.98205,45.41034-10.74018,6.21359-3.55209,11.81642-8.5615,14.97437-15.08057a33.77393,33.77393,0,0,0,2.58061-19.84471c-2.20063-14.77006-10.97326-28.46563-19.7264-40.23015a194.41662,194.41662,0,0,0-33.13969-34.32817,261.40534,261.40534,0,0,0-43.84932-28.56525c-8.23822-4.33745-16.59347-8.5082-24.44456-13.532-7.52769-4.8169-14.95332-10.61273-19.55028-18.43239-3.97592-6.76327-4.70518-14.48236-.564-21.34177,4.18854-6.93785,11.40509-11.77658,18.52153-15.31251,17.146-8.51931,37.08-10.79971,55.83924-13.13648a825.9141,825.9141,0,0,1,121.45058-6.05548q14.79431.348,29.56878,1.22491c1.92857.11345,1.922-2.88693,0-3Z",
    transform: "translate(-183.98585 -127)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M675.5931,132.05212l6.22944-4.98234c-4.83937-.53392-6.82778,2.10537-7.64155,4.19439-3.78071-1.5699-7.89647.48753-7.89647.48753l12.46394,4.52485A9.43172,9.43172,0,0,0,675.5931,132.05212Z",
    transform: "translate(-183.98585 -127)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M645.361,147.82538l6.22944-4.98235c-4.83938-.53391-6.82778,2.10537-7.64156,4.19439-3.78071-1.56989-7.89646.48754-7.89646.48754l12.46393,4.52485A9.43165,9.43165,0,0,0,645.361,147.82538Z",
    transform: "translate(-183.98585 -127)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M675.5931,172.7997l6.22944-4.98234c-4.83937-.53392-6.82778,2.10537-7.64155,4.19439-3.78071-1.5699-7.89647.48753-7.89647.48753l12.46394,4.52485A9.43172,9.43172,0,0,0,675.5931,172.7997Z",
    transform: "translate(-183.98585 -127)",
    fill: "#3f3d56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e2dfab6d-8627-4cc0-b13e-69de57259a01",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bedd3b2f-f695-46eb-9812-80ad4d1341b6",
    "data-name": "Ellipse 7",
    cx: 398.21854,
    cy: 34.41297,
    r: 18.76847,
    fill: "#ff6583"
  }), /*#__PURE__*/React.createElement("path", {
    id: "efdddea5-7f44-48b8-bec9-83339a7f085f-1754",
    "data-name": "Path 63",
    d: "M641.059,219.24736H548.9859a1.88476,1.88476,0,0,1-.34417-.02729L592.189,143.79586a3.04826,3.04826,0,0,1,5.307,0l29.224,50.61377,1.39957,2.42155Z",
    transform: "translate(-183.98585 -127)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f8d22fd6-a75d-4da9-80c1-fba8d7f50740-1755",
    "data-name": "Path 65",
    d: "M692.32061,219.24825H612.68708l15.4306-22.41441,1.11-1.61523,20.10819-29.20986a4.0685,4.0685,0,0,1,6.04372-.36091,3.63814,3.63814,0,0,1,.28961.36091Z",
    transform: "translate(-183.98585 -127)",
    fill: "#6c63ff"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M560.96044,392.23485c8.72718,4.362,14.04042,10.123,14.04042,16.4418,0,13.612-24.63124,24.6467-55.015,24.6467-13.21,0-25.32924-2.08756-34.81287-5.56414,10.07289,5.03473,24.69484,8.20486,40.97454,8.20486,30.38374,0,55.015-11.03469,55.015-24.6467C581.16253,403.62344,573.28981,396.75468,560.96044,392.23485Z",
    transform: "translate(-183.98585 -127)",
    fill: "#f1f1f1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M580.37283,401.58487c9.8476,4.922,15.843,11.42264,15.843,18.55263,0,15.35955-27.79345,27.8109-62.07792,27.8109-14.906,0-28.58106-2.35556-39.28223-6.27847,11.36608,5.68109,27.86523,9.25821,46.23495,9.25821,34.28447,0,62.07792-12.45135,62.07792-27.8109C603.16852,414.43554,594.28508,406.685,580.37283,401.58487Z",
    transform: "translate(-183.98585 -127)",
    fill: "#f1f1f1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M553.53132,396.35329c6.14852,3.07317,9.89184,7.13194,9.89184,11.58368,0,9.59-17.35335,17.36425-38.75949,17.36425a72.80142,72.80142,0,0,1-24.52658-3.92008c7.09662,3.5471,17.39817,5.78054,28.86764,5.78054,21.40614,0,38.7595-7.77423,38.7595-17.36426C567.76423,404.37685,562.21768,399.53763,553.53132,396.35329Z",
    transform: "translate(-183.98585 -127)",
    fill: "#f1f1f1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M467.14078,394.59281s1.3511,19.74867,40.08163,19.74867,50.29379-19.74867,50.29379-19.74867Z",
    transform: "translate(-183.98585 -127)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M522.11455,342.77736a27.18737,27.18737,0,0,0-19.584-5.357A27.28234,27.28234,0,0,1,499.227,391.0495a27.28791,27.28791,0,0,0,22.88759-48.27214Z",
    transform: "translate(-183.98585 -127)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 322.79645,
    y: 206.85629,
    width: 2.64072,
    height: 62.85804,
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M682.96946,287.15271l-.01419-.02423-.03567-1.53542,8.27287-12.01131-8.263,10.86207-.02965.32455-.28281-12.277,7.1455-12.453-7.1657,10.29623.07478-25.43486-.00043-.08467-.00215.08328-.4745,20.04608-6.5124-8.1427,6.49134,9.86965-.14227,10.98156-5.99276-10.71755,5.97084,12.332-.07951,6.10629-.21877,16.91726-.0159,1.26411q.82779.00628,1.63884-.02756l-.37479-16.24935Z",
    transform: "translate(-183.98585 -127)",
    fill: "#cbcbcb"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M643.35868,292.43415l-.01419-.02423-.03567-1.53542,8.27288-12.01132-8.263,10.86208-.02966.32455-.28281-12.277,7.1455-12.453L642.986,275.616l.07478-25.43486-.00043-.08467-.00215.08327-.4745,20.04608-6.5124-8.1427,6.49134,9.86966-.14227,10.98156-5.99276-10.71755,5.97084,12.332-.07951,6.10628-.21877,16.91727-.0159,1.26411q.82781.00628,1.63884-.02756l-.37479-16.24935Z",
    transform: "translate(-183.98585 -127)",
    fill: "#cbcbcb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M662.72395,275.7096l-.01419-.02423-.03567-1.53542,8.27288-12.01132-8.263,10.86207-.02965.32456-.28281-12.277,7.1455-12.453-7.1657,10.29623.07478-25.43486-.00043-.08467-.00215.08327-.4745,20.04608-6.5124-8.1427,6.49134,9.86966-.14227,10.98155-5.99276-10.71755,5.97084,12.332-.07951,6.10628-.21877,16.91727-.0159,1.26411q.82781.00628,1.63884-.02757l-.37479-16.24934Z",
    transform: "translate(-183.98585 -127)",
    fill: "#cbcbcb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.58986,
    cy: 430.43713,
    r: 10.56287,
    fill: "#6c63ff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "715.399 625.419 705.62 629.052 686.952 593.062 701.385 587.7 715.399 625.419",
    fill: "#ffb7b7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M905.40052,760.971,873.869,772.6862l-.14819-.39882a13.09338,13.09338,0,0,1,7.71251-16.83295l.00078-.00029,19.25843-7.15522Z",
    transform: "translate(-183.98585 -127)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "619.162 635.574 608.73 635.573 603.767 595.335 619.164 595.336 619.162 635.574",
    fill: "#ffb7b7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M804.95774,772.6862l-33.63758-.00125v-.42546A13.09339,13.09339,0,0,1,784.41284,759.167h.00084l20.54468.00083Z",
    transform: "translate(-183.98585 -127)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M850.90979,483.50462l-3.40369-6.80737-28.93133,14.46567.85092,5.95645-5.531,7.23283s-9.36014,5.10553-7.65829,22.124l1.70184,16.16751,2.1273,20.84758L795.17443,614.972l-7.6583,68.07372-5.531,54.88444,26.804-1.27638L833.4659,647.307l43.397,96.15413,29.78225-7.65829-40.84423-95.30322-5.10553-39.99331s3.40368-21.273-12.76383-35.73871l2.55277-7.65829v-9.43719l8.50921-45.02179Z",
    transform: "translate(-183.98585 -127)",
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 808.34547,
    y: 613.62109,
    width: 68.9611,
    height: 0.99996,
    transform: "translate(-161.01437 1131.58901) rotate(-74.24881)",
    opacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 624.37786,
    y: 436.49125,
    width: 41.69516,
    height: 4.25461,
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 624.37786,
    cy: 439.04402,
    rx: 1.70184,
    ry: 4.25461,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 827.16658,
    cy: 452.59754,
    r: 22.68164,
    transform: "translate(-299.71319 325.22285) rotate(-28.66322)",
    fill: "#ffb7b7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 677.88911,
    cy: 297.43468,
    r: 20.06577,
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M887.33878,422.28541a20.06687,20.06687,0,1,1-39.14289,8.22881,20.06708,20.06708,0,0,0,39.14289-8.22881Z",
    transform: "translate(-183.98585 -127)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M808.067,446.30036A23.72427,23.72427,0,1,0,822.224,427.20077c-3.96261-3.19569-8.8755-2.20524-12.86957,1.16743-4.51668,3.81351-5.85708,6.4332-9.36,12.70453C803.43881,441.55648,804.6225,445.8166,808.067,446.30036Z",
    transform: "translate(-183.98585 -127)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M891.44105,514.51133c-.25386,6.72194-.75692,19.95277-.75692,20.62813,0,.71163-10.03072,21.48028-14.364,30.41866v.00454c-.3083.63-.58473,1.20114-.82951,1.70428a4.0285,4.0285,0,0,1-3.70315,2.27538l-18.93734-.34a4.03611,4.03611,0,0,1-3.96608-3.93434l-2.11229-83.31478a2.05975,2.05975,0,0,1,2.05785-2.11221h24.4219a5.4908,5.4908,0,0,1,4.94056,3.10032l11.72139,24.24972a15.4994,15.4994,0,0,1,1.52756,7.32025Z",
    transform: "translate(-183.98585 -127)",
    fill: "#6c63ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M848.55453,559.55075a54.23154,54.23154,0,0,1-12.93943-10.93548,60.00786,60.00786,0,0,1-14.95544-34.88819c-.96286-11.07247,1.23419-19.30274,6.53-24.46263,6.73159-6.55907,15.8944-5.60606,16.28116-5.562l.41022.04648,6.20761,5.25261-1.75662,2.076-5.5545-4.7c-1.70019-.085-8.64149-.10336-13.712,4.85623-4.66723,4.56519-6.58376,12.05381-5.69648,22.25783a57.30793,57.30793,0,0,0,14.20782,33.2369,52.6568,52.6568,0,0,0,12.2903,10.44039Z",
    transform: "translate(-183.98585 -127)",
    fill: "#6c63ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 850.45109,
    y: 531.28673,
    width: 33.77971,
    height: 0.90647,
    transform: "translate(-273.22946 58.36779) rotate(-11.60623)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 862.15362,
    y: 479.81912,
    width: 0.90663,
    height: 52.6946,
    transform: "translate(-203.91202 -91.39759) rotate(-2.33745)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M891.44105,514.51133c-.25386,6.72194-.75692,19.95277-.75692,20.62813,0,.71163-10.03072,21.48028-14.364,30.41866l8.07712-46.89939a10.33774,10.33774,0,0,1,6.71289-7.973A15.21462,15.21462,0,0,1,891.44105,514.51133Z",
    transform: "translate(-183.98585 -127)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M841.81531,612.79963a7.979,7.979,0,0,0-2.5951-11.95656l1.64153-18.1595-10.79217-3.68908-1.958,25.67728a8.02231,8.02231,0,0,0,13.70373,8.12786Z",
    transform: "translate(-183.98585 -127)",
    fill: "#ffb7b7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M843.22532,595.228l-19.12309-.69345.809-92.22237a12.44854,12.44854,0,0,1,8.43338-11.8485,11.30933,11.30933,0,0,1,7.11255-.00623,12.45,12.45,0,0,1,8.42155,12.74221Z",
    transform: "translate(-183.98585 -127)",
    fill: "#cbcbcb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.98659,773h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-183.98585 -127)",
    fill: "#cbcbcb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreDraw);
export default __webpack_public_path__ + "static/media/explore-draw.2616030e11204c3e69ca6f8f36ebfbb3.svg";
export { ForwardRef as ReactComponent };